import { permitsTeamPermission, type TeamPermission, type TeamPermissionModule } from "@facturar/auth";
import { isAccountEntryPath } from "./cashier-navigation";

const MODULES: Record<string, TeamPermissionModule> = {
  facturas: "sales_invoices", "notas-credito": "sales_notes", "notas-debito": "sales_notes", pos: "pos",
  compras: "purchases", "documentos-soporte": "support_documents", recibidas: "received_documents",
  terceros: "customers", productos: "products", nomina: "payroll", recibos: "banking", egresos: "banking", bancos: "banking", cartera: "banking",
  contabilidad: "accounting", puc: "chart_accounts", reportes: "reports", impuestos: "taxes", inventario: "inventory", archivos: "files", importaciones: "imports", resoluciones: "dian_config",
};
export function customTeamPageAllowed(path: string, permissions: readonly TeamPermission[]): boolean {
  if (isAccountEntryPath(path) || /^\/(companies|settings|applications)\/?$/.test(path)) return true;
  const match = /^\/companies\/[^/]+\/([^/]+)(.*)$/.exec(path);
  if (!match) return false;
  const module = match[1] === "contabilidad" && match[2].startsWith("/cuentas") ? "chart_accounts" : MODULES[match[1]!];
  if (!module) return false;
  const level = /\/(new|edit)(\/|$)/.test(match[2]!) ? "write" : "read";
  return permitsTeamPermission(permissions, `${module}.${level}`);
}
export function customTeamCompanyHome(companyId: string, permissions: readonly TeamPermission[]): string | undefined {
  return ["facturas", "notas-credito", "pos", "nomina/empleados", "compras", "documentos-soporte", "recibidas", "productos", "terceros", "contabilidad/diario", "contabilidad/cuentas", "bancos", "inventario", "archivos", "impuestos", "reportes/estado-resultados", "importaciones", "resoluciones"]
    .map(path => `/companies/${companyId}/${path}`)
    .find(path => customTeamPageAllowed(path, permissions));
}
